module.exports = __webpack_public_path__ + "files/34bca8b4d8d55aa4e9011c5a39ed336f.png";